/**
 * @author: yuanchang@baidu.com
 * @datetime: 2017-06-28 19:17:37
 * @file: Description
 */
export default {
  isLogin: "/adminunion/isLogin",
  priceList: "/adminunion/getPriceLevel",
  editPrice: "/adminunion/editPriceLevel",
  login: "/adminunion/uuapLogin",
  affList: "/adminunion/affList",
  editAffSmartLink: "/adminunion/editAffSmartLink",
  getAffSmartLink: "/adminunion/getAffSmartLink",
  getAffSmartLinkWeight: "/adminunion/getAffSmartLinkWeight",
  editAffSmartLinkWeight: "/adminunion/editAffSmartLinkWeight",
  editAff: "/adminunion/editAff",
  advList: "/adminunion/advList",
  advManualRevenue: "/adminunion/advManualRevenueList",
  advBalanceTurnover: "/adminunion/advBalanceTurnover",
  dailyReport: "/adminunion/overviewSummary",
  dailyReportCash: "/adminunion/topDataCashDetail",
  editAdvManualRevenue: "/adminunion/editAdvManualRevenue",
  editAdv: "/adminunion/editAdv",
  capList: "/adminunion/capList",
  editCap: "/adminunion/editCap",
  discountList: "/adminunion/discountList",
  editDiscount: "/adminunion/editDiscount",
  blackList: "/adminunion/blackList",
  editBlack: "/adminunion/editBlack",
  emailPreview: "/adminunion/emailBlack",
  offerList: "/adminunion/offerList",
  editOffer: "/adminunion/editOffer",
  affPayList: "/adminunion/affPayList",
  advPayList: "/adminunion/advPayList",
  overviewData: "/adminunion/overviewData",
  overviewDataCash: "/adminunion/overviewDataCashCash",
  offerTagList: "/adminunion/offerTagList",
  offerTagDetail: "/adminunion/offerTagDetail",
  topData: "/adminunion/topData",
  topDataCash: "/adminunion/topDataCash",
  hourDataCash: "/adminunion/cashRealtime",
  uniqueCash: "/adminunion/cashUnique",
  getAdvAff: "/adminunion/getAdvAff",
  detailData: "/adminunion/detailData",
  detailCashData: "/adminunion/detailCashData",
  profitData: "/adminunion/profitData",
  affDeductEvidence: "/adminunion/affDeductEvidence",
  uploadEvidence: "/adminunion/uploadEvidence",
  editAdvDeduct: "/adminunion/editAdvDeduct",
  editAffDeduct: "/adminunion/editAffDeduct",
  advDeductList: "/adminunion/advDeductList",
  affDeductList: "/adminunion/affDeductList",
  affDiscoutEmail: "/adminunion/emailAffDeduct",
  getCapLog: "/adminunion/getCapLog",
  logQuery: "/adminunion/logQuery",
  authOfferList: "/adminunion/authOfferList",
  editAuthOffer: "/adminunion/editAuthOffer",
  advGradeList: "/adminunion/advGradeList",
  editAdvGrade: "/adminunion/editAdvGrade",
  affGradeList: "/adminunion/affGradeList",
  editAffGrade: "/adminunion/editAffGrade",
  // advAffPayList: '/adminunion/advAffPayList',
  // editAdvAffPay: '/adminunion/editAdvAffPay',
  editAffPay: "/adminunion/editAffPay",
  editAdvPay: "/adminunion/editAdvPay",
  getAffPayList: "/adminunion/getAffPayList",
  getAdvPayList: "/adminunion/getAdvPayList",
  emailAffPay: "/adminunion/emailAffPay",
  getOffersUrl: "/click/getOffers",
  getEmailData: "/adminunion/getEmailData",
  handleEmail: "/adminunion/handleEmail",
  detailConvTime: "/adminunion/detailConvTime",
  detailClickQuality: "/adminunion/detailClickQuality",
  detailConvQuality: "/adminunion/detailConvQuality",
  affAutoDeductList: "/adminunion/affAutoDeductList",
  affAutoDeduct: "/adminunion/affAutoDeduct",
  detailAutoDeductList: "/adminunion/detailAutoDeductList",
  affLevelList: "/adminunion/affQualityList",
  editAffLevel: "/adminunion/editAffQuality",
  offerCopy: "/adminunion/offerCopy",
  getVirtualAdvList: "/adminunion/getVirtualAdvList",
  delAffDeduct: "/adminunion/delAffDeduct",
  delAdvDeduct: "/adminunion/delAdvDeduct",
  getAdvAuthAff: "/adminunion/getAdvAuthAff",
  getAffAuthAdv: "/adminunion/getAffAuthAdv",
  getDirectOfferList: "/adminunion/directOfferList",
  editDirectOffer: "/adminunion/editDirectOffer",
  editDirectOfferCap: "/adminunion/editDirectOfferCap",
  getCapOffer: "/adminunion/offerCapList",
  editCapOffer: "/adminunion/editApiOfferCap",
  getOfferFilter: "/adminunion/getOfferFilterList",
  editOfferFilter: "/adminunion/editOfferFilter",
  fictionlist: "/adminunion/getBookList ",
  editFiction: "/adminunion/editBook",
  getHotFiction: "/adminunion/getHotSearchList",
  editHotFiction: "/adminunion/editHotSearch",
  getDefaultCap: "/adminunion/getDefaultOfferCap",
  editDefaultCap: "/adminunion/editDefaultOfferCap",
  smallDetailData: "/adminunion/smallDetailData",

  // 广告素材url
  getOfferMaterialList: "/adminunion/getAdwordsAd",
  editOfferMaterial: "/adminunion/editAdwordsAd",
  uploadOfferMaterialImg: "/adminunion/uploadAdMaterial?img_type=1",
  uploadOfferMaterialIcon: "/adminunion/uploadAdMaterial?img_type=0",

  // 广告拉取黑名单url
  getOfferBlackList: "/adminunion/getPkgCountryBlacklist",
  editOfferBlack: "/adminunion/editPkgCountryBlacklist",

  // offer豁免页url
  getOfferExemptList: "/adminunion/exemptOfferList",
  editOfferExempt: "/adminunion/editExemptOffer",

  // H5章节
  getChapterList: "/adminunion/getChapterList",
  editChapter: "/adminunion/editChapter",
  getBookInfo: "/adminunion/getBookInfo",

  // 内容审核
  contentForm: "/adminunion/media/getNews",
  contentFormEdit: "/adminunion/media/editNews",
  contentFormStatus: "/adminunion/media/updateNewsStatus",

  // offer加价加量列表
  offerDiscountList: "/adminunion/offerDiscountList",
  editOfferDiscount: "/adminunion/editOfferDiscount",

  // 广告活动系列
  getCampaignsList: "/dspapi/v1/campaigns",
  addCampaign: "/dspapi/v1/campaigns/",
  getCampaign: "/dspapi/v1/campaigns/",
  updateCampaign: "/dspapi/v1/campaigns/",
  updateCampaignStatus: "/dspapi/v1/campaigns/",
  deleteCampaign: "/dspapi/v1/campaigns/",
  getAllCampaigns: "/dspapi/v1/campaigns/all-campaigns/",
  getAllOperators: "/dspapi/v1/sms/operator",
  getAllTags: "/dspapi/v1/sms/tag",
  getAllSources: "/dspapi/v1/sms/source",
  beforeDateList: "/dspapi/v1/sms/time",

  // 广告组系列
  getAdGroupsList: "/dspapi/v1/groups",
  addAdGroup: "/dspapi/v1/groups/",
  getAdGroup: "/dspapi/v1/groups/",
  updateAdGroup: "/dspapi/v1/groups/",
  deleteAdGroup: "/dspapi/v1/groups/",
  updateAdGroupStatus: "/dspapi/v1/groups/",
  getAllGroups: "/dspapi/v1/groups/all-groups/",

  // 广告系列
  getAdvertsList: "/dspapi/v1/adverts",
  addAdvert: "/dspapi/v1/adverts/",
  getAdvert: "/dspapi/v1/adverts/",
  deleteAdvert: "/dspapi/v1/adverts/",
  updateAdvert: "/dspapi/v1/adverts/",
  updateAdvertStatus: "/dspapi/v1/adverts/",

  //finance
  editAdvCashFiance: "/adminunion/editCashFinance",
  advCashFianceList: "/adminunion/cashFinance",
  editCashFinanceServices: "/adminunion/editCashFinanceServices",
  editCashFinanceTerms: "/adminunion/editCashFinanceTerms",
  cashBalanceTurnover: "/adminunion/cashTurnover",
  cashBillDetail: "/adminunion/cashBillDetail",
  cashBillChangeStatus: "/adminunion/cashBillChangeStatus",
  cashBillItem: "/adminunion/cashBillItem",
  importPayments: "/adminunion/importPayments",
  importTransactions: "/adminunion/importTransactions",
  getransactions: "/adminunion/cashTransaction",
  importTurnoverCash: "/adminunion/importTurnoverCash",

  //pkgCost
  pkgCostDailyList: "/adminunion/pkgManualCostList",
  editPkgCostDailyList: "/adminunion/editPkgManualCostList",
  pkgAutoCostDailyList: "/adminunion/pkgAutoCostList",

  // Settings
  getSettings: "/adminunion/getSettings",
  updateSettings: "/adminunion/updateSettings",

};



// WEBPACK FOOTER //
// ./src/http/url.js